// extracted by css-extract-rspack-plugin
export default {"container":"status-picker-module__container__2VI_slE"};